import React from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import * as styles from "./progressBar.module.scss"
import { IProgressBarGreen } from "./types"

export default function ProgressBarGreen({
  widthGreenBar,
  widthAnimationBar = 50,
  steps = 1,
  variant,
}: IProgressBarGreen) {
  return (
    <Container className={clsx(styles.container, variant && styles[variant])}>
      {variant !== "redesignPkw" ? (
        <>
          <h4 className={styles.title}>
            <span className={styles.steps}> Шаг {steps} из 2.</span> Получите{" "}
            <span className={styles.green}>{steps === 1 ? "+50%" : "+40%"} к одобрению</span> за
            заполнение контактной информации
          </h4>
          <div className={styles.progressBar}>
            <div className={styles.animationBar} style={{ width: `${widthAnimationBar}%` }} />
            <div className={styles.greenBar} style={{ width: `${widthGreenBar}%` }} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.textBlock}>
            <h4>Шаг {steps} из 2</h4>
            <p>+{steps === 1 ? "50%" : "40%"} к одобрению</p>
          </div>
          <div className={styles.track}>
            <div className={styles.shadow} style={{ width: `${widthAnimationBar}%` }} />
            <div className={styles.fill} style={{ width: `${widthGreenBar}%` }} />
          </div>
        </>
      )}
    </Container>
  )
}
